import { apiService } from "@/services";
import { settings } from "@/settings";
import { RequestsClient } from "./GeneratedClients";

const requestRepository = new RequestsClient(settings.webApi.baseUrl, apiService.getApiClient());

export { requestRepository };
